module.exports = __webpack_public_path__ + "static/media/move.1fccb2d1.svg";